<div class="mainFrame__header"
     [class.success]="notification?.level == notificationLevel['Info']">
    <h1 *ngIf="!notification">Taxonomy Builder</h1>
    <h1 *ngIf="notification">{{notification.message}}</h1>
</div>
